import { CURRENT_CLIENT } from '@/constants'

import type { PaneResponsiveCardGridMaxColumns } from '@/components/layout/pane-responsive-card-grid-classes'

type ClientWithCardListLayout = {
  layout?: {
    entityCardListMaxColumns?: PaneResponsiveCardGridMaxColumns
  }
}

export function resolveEntityCardListMaxColumns(
  override?: PaneResponsiveCardGridMaxColumns,
): PaneResponsiveCardGridMaxColumns {
  if (override != null) return override

  const fromConfig = (CURRENT_CLIENT as ClientWithCardListLayout).layout?.entityCardListMaxColumns
  if (fromConfig != null) return fromConfig

  return 4
}
